var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstituteIconForPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.8022 89.9456H0.802246V92.7756H92.8022V89.9456Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6547 88.4855V45.3831H20.9497V88.4855H23.7798V48.2131H69.8246V88.4855H72.6547Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4272 52.5256V49.6956H26.6772V52.5256H28.1372V85.6332H26.6772V88.4632H32.4272V85.6332H30.9673V52.5256H32.4272Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0522 52.5256V49.6956H35.3022V52.5256H36.7622V85.6332H35.3022V88.4632H41.0522V85.6332H39.5923V52.5256H41.0522Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6772 52.5256V49.6956H43.9272V52.5256H45.3874V85.6332H43.9272V88.4632H49.6772V85.6332H48.2175V52.5256H49.6772Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3022 52.5256V49.6956H52.5522V52.5256H54.012V85.6332H52.5522V88.4632H58.3022V85.6332H56.8423V52.5256H58.3022Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9274 52.5257V49.6956H65.4673V49.6733H62.6372V49.6956H61.1772V52.5257H62.6372V85.6332H61.1772V88.4633H66.9274V85.6332H65.4673V52.5257H66.9274Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.552 41.0703H18.0525V43.9004H75.552V41.0703Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4902 56.8828H0.802246V59.7129H19.4902V56.8828Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8419 31.3886L48.2172 21.326V0.79834H45.3871V21.3262L13.762 31.3886V39.5883H79.8419V31.3886ZM16.592 36.7582V33.4579L46.8019 23.8457L77.0118 33.4579V36.7582H16.592Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4673 0.820801H49.6772V3.65087H62.6372V8.00829H49.6772V10.8384H65.4673V0.820801Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8247 12.3208H56.8647V15.1509H72.6548V5.1333H66.9274V7.96337H69.8247V12.3208Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2173 29.5481H45.3872V32.4231H48.2173V29.5481Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0597 61.1949L2.24707 61.1443L2.23801 63.9744L18.0507 64.025L18.0597 61.1949Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0605 75.6209L2.2478 75.5703L2.23875 78.4004L18.0514 78.451L18.0605 75.6209Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96728 66.9238H5.13721V72.6738H7.96728V66.9238Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1545 66.9238H12.3245V72.6738H15.1545V66.9238Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96728 81.2988H5.13721V87.049H7.96728V81.2988Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1545 81.2988H12.3245V87.049H15.1545V81.2988Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8025 56.8828H74.1145V59.7129H92.8025V56.8828Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5501 63.9704L91.3628 64.021L91.3718 61.1909L75.5592 61.1403L75.5501 63.9704Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3734 75.6177L75.5608 75.5671L75.5517 78.3972L91.3644 78.4478L91.3734 75.6177Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2803 66.9238H78.4502V72.6738H81.2803V66.9238Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4665 66.9238H85.6365V72.6738H88.4665V66.9238Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2803 81.2988H78.4502V87.049H81.2803V81.2988Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4665 81.2988H85.6365V87.049H88.4665V81.2988Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituteIconForPopup);
export default __webpack_public_path__ + "static/media/institute-icon-for-popup.24028d8b5900bd84654b1082c3d5b3c0.svg";
export { ForwardRef as ReactComponent };